import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=5f208e2c&scoped=true&"
import script from "./FaqCard.vue?vue&type=script&lang=js&"
export * from "./FaqCard.vue?vue&type=script&lang=js&"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=5f208e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f208e2c",
  null
  
)

export default component.exports